export default "__VITE_ASSET__CeDOC8DT__"